import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['orderForm', 'magicLinkForm']

  showOrderForm(event) {
    event.preventDefault()
    this.orderFormTarget.classList.remove('hidden')
    this.magicLinkFormTarget.classList.add('hidden')
  }

  showMagicLinkForm(event) {
    event.preventDefault()
    this.magicLinkFormTarget.classList.remove('hidden')
    this.orderFormTarget.classList.add('hidden')
  }
}
